<template>
  <div ref="video">
    <iframe :src="source" allowfullscreen allowtransparency allow-same-origin="*" allow="autoplay"></iframe>
  </div>
</template>

<script>
import Plyr from 'plyr/dist/plyr';
// import controls from './controls'

export default {
  name: 'video-player',
  props: {
    source: {
      type: String,
      required: true,
    },
    setVideoState: {
      type: Function,
      required: false,
      default: () => {},
    },
    options: {
      type: Object,
      required: true,
    },
    isPlaying: {
      type: Boolean,
    },
    emit: {
      type: Array,
      required: false,
      default() { return []; },
    },
  },

  mounted() {
    if (!this.player) {
      window.localStorage.removeItem('plyr');
      this.initialize();
    }
  },

  methods: {
    initialize() {
      // options
      const videoOptions = Object.assign({
        customEventName: 'statechanged',
        controls: [],
        start: 0,
        volume: 0,
        settings: [],
        tooltips: { controls: false, seek: false },
        autoplay: true,
        loop: {
          active: true,
        },
        muted: true,
      }, this.options);
      this.videoOptions = videoOptions;

      // ios fullscreen
      const playsinline = videoOptions.playsinline;
      if (playsinline) {
        this.$el.children[0].setAttribute('playsinline', playsinline);
        this.$el.children[0].setAttribute('webkit-playsinline', playsinline);
      }

      this.player = new Plyr(this.$refs.video, videoOptions);

      if (this.player !== null) {
        this.$emit('ready', this.player);

        this.emit.forEach((element) => {
          this.player.on(element, this.emitPlayerEvent);
        });
        this.player.on('play', this.emitPlayerEvent);
      }
    },

    emitPlayerEvent() {
      this.$emit(event.type, event)
      if (event.type === 'pause') this.setVideoState(false);
      if (event.type === 'play') this.setVideoState(true);
    },

    dispose() {
      if (this.player) {
        if (this.player.pause) this.player.pause();

        if (!this.$el.children.length) {
          const video = document.createElement('video');
          this.$el.appendChild(video);
          this.player.destroy();
        }

        this.player = null;
      }
    },
  },

  watch: {
    isPlaying(val) {
      if (val) {
        this.player.play();
      }
    },
    options: {
      deep: true,
      handler(options) {
        this.dispose();
        if (options && options.sources && options.sources.length) {
          this.initialize();
        }
      },
    },
  },
};
</script>

<style lang="scss">
@import './scss/variables.scss';
@import './scss/mixins.scss';
@import '~plyr/src/sass/plyr.scss';

.plyr {
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    box-shadow: inset 15px 5px 50px 20px #000,
      inset -15px 15px 50px 20px #000,
      inset 15px -30px 50px 20px #000,
      inset -15px 30px 50px 20px #000;

    pointer-events: none;
  }
}

.plyr.plyr--stopped > div {
  opacity: 0;
  transition: opacity 0.8s ease-in-out;
}

.plyr.plyr--playing > div {
  opacity: 1;
}
</style>
